import { YearLimit } from 'src/redux/modules/user/UserRegistrationTypes/types';
import {
  AGREEMENT_TYPES,
  ExchangeType,
  UNIT,
  US_STATE_CODE,
} from 'src/settings/settings';

export interface Ranking {
  asOfDate: undefined;
  percentTotalNetAssets: number;
  name: string;
}
export interface Allocation {
  stocks: number;
  bonds: number;
  shortTermReserves: number;
  asOfDate: undefined;
}

export interface Address {
  contactID: string;
  street1: string;
  countryCode: string;
  street2: string;
  state: US_STATE_CODE;
  country: string;
  city: string;
  zip: string;
  zipCodeExt: string;
  effectiveDate: Date;
}
export enum RoleCode {
  DLR = 'DLR',
  OWNER = 'OWNR',
  MINOR = 'MINR',
  CUST = 'CUST',
  POA = 'AGNT',
}

export enum DisplayClassification {
  RETIREMENT = 'RETIREMENT',
  NON_RETIREMENT = 'NON_RETIREMENT',
  COLLEGE_SAVINGS = 'COLLEGE_SAVINGS',
}
export interface AgreementParty {
  businessPartyID: number;
  roleCode: RoleCode;
  fullName: string;
  primaryParty: 'Y' | 'N';
}

export interface Fund {
  correspondingFund?;
  fundType?: string;
  fundLock?;
  address: Address;
  addressChangedSameDay: boolean;
  agreementID: string;
  agreementNumber?: string;
  agreementParties?: AgreementParty[];
  agreementType: AGREEMENT_TYPES;
  allocation: Allocation;
  assetAllocationRankings?: Ranking[];
  availableShares?: number;
  balanceAsOf;
  balanceAsOfDate;
  BPID?: string;
  canExchange?: boolean;
  chargeables;
  chargeableShareQuantity?: number;
  closeout?: boolean;
  closeoutFee?;
  contributionYear?: unknown;
  coveredShares: number;
  currentYearAmount: number;
  currentYearAmountUnit: UNIT;
  currentYearLimit;
  disabled?: boolean;
  displayClassification?: DisplayClassification;
  equityAsOf;
  federalWithholdingApplied?: boolean;
  federalWithholdingDollars?: number;
  federalWithholdingPercent?;
  financialPlanningGroupID?;
  formattedEntityNames?;
  fundLimitMessage: string;
  fundName: string;
  grossAmount: number;
  grossAmountDollars: number;
  grossAmountError: unknown;
  grossPercentShares: number;
  grossUnit: UNIT;
  hasIRAAutoMax?: boolean;
  hasPendingTransaction: boolean;
  hasUncollectedShares?: boolean;
  hiddenFromOnlineCustomer?: boolean;
  iClass;
  inFocus: boolean;
  investmentVehicleKey;
  isFundAssociable: boolean;
  isFundRMDEligible?: boolean;
  isIRAContribution?: boolean;
  isTakeHomeEstimated?: boolean;
  linkedAgreementNumber?;
  minimumInvestmentAmount: number;
  modelAgreementUniqueIDs(modelAgreementUniqueIDs);
  moneyMarketReformMessage: string;
  moneyMarketReformMessagePeriod: string;
  moneyMarketReformMessageType: string;
  name: string;
  netDollarAmount?: number;
  netDollarIsEstimate?: boolean;
  newFund: boolean;
  nonRetirementLike?: boolean;
  notes?;
  priorYearAmount;
  productType;
  openToSubsequentInvestments: boolean;
  purchaseBlocked?: boolean;
  purchaseBlockRemovalDate;
  recurringTransactionTypes?;
  redeemableFundDollars: number;
  registrationGroup?: string;
  restrictedByAddressChange: boolean;
  selected?: boolean;
  sharePrice: number;
  shares: number;
  stateIsEstimate?: boolean;
  stateWithholdingApplied?: boolean;
  stateWithholdingDisabled?: boolean;
  stateWithholdingDollars?: number;
  stateWithholdingPercent?: number;
  summit;
  sweep?: boolean;
  ticker: string;
  transactionFees?;
  transactionLimit: YearLimit;
  trpCode: string;
  uncoveredShares?: number;
  uniqueKey: string;
  viewOnly?: boolean;
  unfundedNASUAccount?: boolean;
}

export type ExchangeTypeOrUnit = ExchangeType | UNIT | string;

export function isShares(unit: string | UNIT): unit is UNIT.SHARES {
  return (
    (unit as string)?.toUpperCase() === UNIT.SHARES ||
    (unit as string)?.toUpperCase() === UNIT.ALL_SHARES
  );
}

export function isPercent(unit: string | UNIT): unit is UNIT.PERCENT {
  return (unit as string)?.toUpperCase() === UNIT.PERCENT;
}
